import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { InitializeScreenComponent } from './initialize-screen.component';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule],
    declarations: [InitializeScreenComponent],
    exports: [InitializeScreenComponent]
})
export class InitializeScreenModule {}
